import React, { useEffect, useMemo, useState } from 'react';
import useDebounce from '../hooks/useDebounce';
import useUpdateEffect from '../hooks/useUpdateEffect';
import { updateData } from '../utils/filterHelperFunctions';
import { RiFilter3Fill } from 'react-icons/ri';
import { RxCross2 } from 'react-icons/rx';
import MultiselectWithApi from '../features/MultiselectWithApi/MultiselectWithApi';
import ObjectDropDown from 'lib/reusable-components/Components/DropDowns/ObjectDropDown';
import { primitiveValues, textConditionData } from '../data/defaultFilterSchema';
import { mls } from 'lib/multilanguagesupport';

interface filterItemsCATProps {
  elem: any;
  selectedColumns: any[];
  index: number;
  setSelectedColumns: (columns: any[]) => void;
  appID: string;
  sheetID: string;
  isJoinedTable?: string | boolean;
  handleRemoveColumnSelection: (elem: any) => void;
}
const FilterItemsCAT = ({
  elem,
  selectedColumns,
  index,
  setSelectedColumns,
  appID,
  sheetID,
  isJoinedTable,
  handleRemoveColumnSelection,
}: filterItemsCATProps) => {
  const [selectedData, setSelectedData] = useState(
    elem?.value ?? {
      value: [],
      condition: textConditionData.contains.key,
    }
  );
  const debounceValue = useDebounce(selectedData);

  const handleColumnValue = (selectedItems: any) => {
    const newSelectedData = { ...selectedData, value: selectedItems };
    setSelectedData(newSelectedData);
  };
  const handleColumnSelection = (selectedItems: any[]) => {
    handleColumnValue([...selectedItems]);
  };
  const selectedConditionType =
    textConditionData?.[
      (selectedData?.condition as keyof typeof textConditionData) ??
        (textConditionData.contains.key as keyof typeof textConditionData)
    ] || {};
  const isValueTypeArray = selectedConditionType?.valueTypeArray ?? false;
  const newUniqueValues = useMemo(() => {
    return (elem?.filterData?.uniqueValues || []).map((data: any) => {
      return `${data}`;
    });
  }, [elem]);
  const handleConditon = (action: any) => {
    const newSelectedData = {
      ...selectedData,
      condition: action,
      value: textConditionData?.[action as keyof typeof textConditionData]?.defaultValue ?? '',
    };

    setSelectedData(newSelectedData);
  };
  useUpdateEffect(() => {
    const value = selectedData;
    const getData = updateData(selectedColumns, index, value);
    setSelectedColumns(getData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounceValue]);

  useEffect(() => {
    // setSelectedData(elem?.value ?? []);
    setSelectedData(
      elem?.value ?? {
        value: '',
        condition: textConditionData.contains.key,
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [`${elem?.columnName}.${elem?.tableName}`]);

  return (
    <div className='containerItems'>
      <div className='Title'>
        <div className='filterIcon'>
          <RiFilter3Fill />
        </div>
        <div className='titleName'>{elem.name}</div>
        <div className='removeFilter' onClick={() => handleRemoveColumnSelection(elem)}>
          <RxCross2 />
        </div>
      </div>
      <div className='titleDiv'>{mls('Condition')}</div>
      <ObjectDropDown
        object={textConditionData}
        dropDownValue={selectedData?.condition ?? textConditionData.contains.key}
        setdropDownValue={handleConditon}
        ObjectInObject
      />
      {selectedConditionType.key !== textConditionData.regexp.key ? (
        <div className='primitiveValuesContainer'>
          {React.Children.toArray(
            primitiveValues.map((primitiveElem) => {
              const isSelected = isValueTypeArray
                ? (selectedData?.value ?? []).some((elem: any) => elem === primitiveElem?.key)
                : selectedData?.value === primitiveElem?.key;
              const handlePrimitiveSelection = ({ isSelected, key }: any) => {
                if (isSelected) {
                  if (isValueTypeArray) {
                    const filterdData = (selectedData?.value ?? []).filter(
                      (item: any) => item !== key
                    );
                    handleColumnValue(filterdData);
                  } else {
                    handleColumnValue('');
                  }
                  return;
                }
                if (isValueTypeArray) {
                  handleColumnValue([...selectedData?.value, key]);
                } else {
                  handleColumnValue(key);
                }
              };
              return (
                <div
                  className={`primitiveElem ${isSelected ? 'selectedPrimitiveElem' : ''}`}
                  onClick={() => handlePrimitiveSelection({ isSelected, key: primitiveElem?.key })}
                >
                  {primitiveElem.name}
                </div>
              );
            })
          )}
        </div>
      ) : null}
      <>
        <div className='titleDiv'>{mls('Value')}</div>
        <div className='multiSelectColumn'>
          {isValueTypeArray ? (
            <MultiselectWithApi
              targetElem={elem}
              appID={appID}
              sheetID={sheetID}
              isJoinedTable={isJoinedTable}
              options={newUniqueValues} // Options to display in the dropdown
              onSelect={handleColumnSelection} // Function will trigger on select event
              onRemove={handleColumnSelection} // Function will trigger on remove event
              // selectedValues={[...filteredSelectedData]}
              selectedValues={selectedData?.value ?? []}
              // displayValue="name" // Property name to display in the dropdown options
              showCheckbox
              isObject={false}
            />
          ) : (
            <input
              className='primaryInput'
              type='text'
              placeholder={mls('Select')}
              value={`${selectedData?.value}` || ''}
              onChange={(e) => handleColumnValue(e.target.value)}
            />
          )}
        </div>
      </>
    </div>
  );
};
export default FilterItemsCAT;
